module.exports = __webpack_public_path__ + "img/expressage-icon-01.0c27efb2.png";